import { createElement } from "@max/max";
import View from '@hfe/max-view';
import { LayoutType } from '@/types/shared';
import './index.scss';
import Price from "@/components/common/Price/index.web";
import Button from '@/components/common/Button';
import CountDownDescription, { TextType } from '@/components/common/CountDownDescription';
import CouponTitle from '@/components/common/CouponTitle';
import CouponThreshold from '@/components/common/CouponThreshold';
import { formatRequireAmount } from '@/utils/common';
export var StyleType;
(function (StyleType) {
    StyleType["horizontal"] = "horizontal";
    StyleType["normal"] = "normal";
})(StyleType || (StyleType = {}));
const style = {
    horizontal: {
        cardContainer: {
            width: '226rpx',
            height: '256rpx'
        },
        titleText: {
            maxWidth: '168rpx',
            alignItems: 'center',
            justifyContent: 'center'
        }
    },
    normal: {
        cardContainer: {
            width: '226rpx',
            height: '256rpx'
        },
        titleText: {
            maxWidth: '168rpx',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }
};
const CouponCardTriple = ({ prize, onPress, styleType = StyleType.normal }) => {
    const isButtonValid = prize.isButtonValid;
    const requireAmount = formatRequireAmount(prize.requireAmount);
    return <View className="coupon-card-triple" style={style[styleType].cardContainer} onClick={() => onPress?.(prize)}>
      <View className="info-section">
        <CouponTitle title={prize.prizeName} style={style[styleType].titleText} layoutType={LayoutType.TRIPLE}/>
      </View>

      <View className="coupon-content-triple">
        <View className="amount-section-triple">
          <Price amount={prize.amount} amountType={prize.amountType} rewardType={prize.rewardType} layoutType={LayoutType.TRIPLE}/>
          <CouponThreshold text={requireAmount} style={{
            marginTop: '-8rpx'
        }}/>
        </View>

        <View className="button-wrapper-triple">
          <Button children={prize.buttonText} fontSize={24} width={136} height={48} handlePress={() => onPress?.(prize)} backgroundColor={isButtonValid ? '#FF2D19' : '#CCCCCC'}/>
        </View>

        <View className="expire-time-wrapper-triple">
          <CountDownDescription prize={prize} textType={TextType.SMALL}></CountDownDescription>
        </View>
      </View>
    </View>;
};
export default CouponCardTriple;
